import i18next from "i18next";

export function getFriendlyErrorMessage(error: any): string {
  if (!error) return "";
  
  const currentLang = i18next.language || "ar";
  
  // Extract error string
  let errorStr = "";
  if (typeof error === "string") {
    errorStr = error;
  } else if (error instanceof Error) {
    errorStr = error.message;
  } else if (error && typeof error === "object") {
    errorStr = error.message || error.error || error.response || JSON.stringify(error);
  }
  
  const cleanError = errorStr.toLowerCase();
  
  // Define error mappings for Arabic and English
  const mappings: Record<string, { ar: string; en: string }> = {
    "network error": {
      ar: "عذراً، حدث خطأ في الاتصال بالشبكة. يرجى التحقق من اتصالك بالإنترنت وإعادة المحاولة.",
      en: "Network error. Please check your internet connection and try again."
    },
    "failed to fetch": {
      ar: "فشل الاتصال بالخادم. يرجى التأكد من تشغيل خادم الـ Backend والمحاولة مرة أخرى.",
      en: "Failed to connect to server. Please ensure the backend is running and try again."
    },
    "session not found": {
      ar: "جلسة العمل غير موجودة أو انتهت صلاحيتها. يرجى تسجيل الدخول مجدداً.",
      en: "Session not found or expired. Please log in again."
    },
    "failed to send": {
      ar: "فشل إرسال الرسالة. يرجى التأكد من اتصال الرقم بالواتساب وصحة الرقم.",
      en: "Failed to send message. Please ensure the recipient number is valid and connected."
    },
    "rate limit": {
      ar: "لقد تجاوزت عدد العمليات المسموح بها. يرجى المحاولة مرة أخرى بعد قليل.",
      en: "Rate limit exceeded. Please try again in a few moments."
    },
    "unauthorized": {
      ar: "غير مصرح لك بالقيام بهذا الإجراء. يرجى تسجيل الدخول مجدداً.",
      en: "Unauthorized access. Please log in again."
    },
    "token": {
      ar: "رمز الاتصال غير صالح أو انتهت صلاحيته. يرجى إعادة توليد رمز جديد.",
      en: "Authentication token is invalid or expired. Please regenerate a new token."
    },
    "timeout": {
      ar: "انتهت مهلة الطلب. يرجى إعادة المحاولة.",
      en: "Request timed out. Please try again."
    },
    "qr": {
      ar: "فشل إنشاء رمز الاستجابة السريعة (QR Code). يرجى التأكد من حالة اتصال الهاتف والشبكة.",
      en: "Failed to generate QR Code. Please check phone connection and try again."
    },
    "phone": {
      ar: "الرقم المدخل غير صحيح أو غير مسجل في الواتساب.",
      en: "The phone number is invalid or not registered on WhatsApp."
    },
    "invalid format": {
      ar: "صيغة الملف المدخل غير صالحة. يرجى التأكد من اختيار ملف متوافق.",
      en: "Invalid file format. Please ensure you upload a supported file type."
    }
  };
  
  // Find matching pattern
  for (const [key, val] of Object.entries(mappings)) {
    if (cleanError.includes(key)) {
      return currentLang.startsWith("ar") ? val.ar : val.en;
    }
  }
  
  // Fallback friendly message
  return currentLang.startsWith("ar") 
    ? "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى لاحقاً." 
    : "An unexpected error occurred. Please try again later.";
}
